import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostAssignedProjectFormFields {

    public name: FormField
    public person: FormField
    public project: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.person = new FormField(
          'person',
          'Person',
          'person',
          FormFieldType.pushedSelectionList,
          true,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostAssignedProjectFormFields()

export const postAssignedProjectFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  person: fields.person,
  project: fields.project,
};